export const BQ_CLICKED_PACKAGE_SELECT = 'clicked_package_select';
export const BQ_CLICKED_CUSTOM_ORDER = 'gig_page.click_on_get_quote';
export const BQ_CLICKED_REPORT_GIG = 'gig_report.click';
export const BQ_GIG_DESCRIPTION_SEE_MORE = 'clicked_on_see_more_gig_description';
export const BQ_CLICKED_CONTACT_SELLER = 'clicked_on_contact_seller';
export const BQ_CLICKED_PACKAGES_TAB = 'clicked_on_packages_tab';
export const BQ_CLICKED_REVIEWS_SNIPPET_MORE = 'clicked_on_show_more';
export const BQ_OPEN_COUPON_ARTICLE = 'clicked_on_learn_more_about_coupons';
export const BQ_SEEN_BOMBA_COUPON = 'learn_more_about_coupons_bomba_is_shown';
export const BQ_SELLER_BUYER_SPEAK_SAME_LANGUAGE = 'seller_and_buyer_speak_the_same_language';
export const BQ_CLICKED_GALLERY_VIDEO = 'video_play';
export const BQ_CLICKED_SELLER_LINK = 'clicked_on_seller_name_gig_page';
export const BQ_CLICKED_SELLER_NAME_ANCHOR = 'clicked_on_seller_icon_gig_page';
export const BQ_CLICKED_TOPNAV = 'clicked_on_top_bar_gig_page';
export const BQ_CLICKED_REVIEWS_RATINGS = 'clicked_on_ratings_stars_gig_page';
export const BQ_PAGE_TRANSLATED_BY_EXTENSION = 'page_translated_by_extension';
export const BQ_STICKY_EXPERIENCE = 'mt_sticky_experience';
export const BQ_CLICKED_ON_CONTACT_SELLER_OPTIONS = 'clicked_on_contact_seller_options';
export const BQ_SIGNUP_CLICK = 'signup_click';
export const BQ_NOTABLE_CLIENTS_ABOVE_THE_FOLD_SHOW = 'notable_client_above_the_fold_component_is_shown';
export const BQ_NOTABLE_CLIENTS_BELOW_THE_FOLD_SHOW = 'notable_client_below_the_fold_component_is_shown';
export const BQ_NOTABLE_CLIENT_GIG_ELIGIBLE = 'viewed_gig_notable_clients_eligible';
export const BQ_CLICKED_ON_PAYMENT_DETAILS = 'price_summary_is_shown';
export const BQ_CLICKED_ON_CONTINUE_IN_WORK_PROCESS_DRAWER = 'click_on_payment_method';
export const BQ_GIG_PAGE_WITHOUT_EXTRAS = 'gig_page_without_extras';
export const BQ_VOICE_OVER_AI_AUDITION_SUCCESS = 'ai_audition_success';
export const BQ_VOICE_OVER_AI_AUDITION_CLICKED_ON_PLAY = 'clicked_on_play_ai_audition';
export const BQ_VOICE_OVER_AI_AUDITION_ERROR_MESSAGE_IS_SHOWN = 'ai_audition_error_message_is_shown';
export const BQ_PAYMENT_DRAWER_IS_SHOWN = 'payment_drawer_is_shown';
export const BQ_CLICK_ON_SUBSCRIBE_OPTION = 'clicked_on_subscription_options_in_drawer';
